module.exports = __webpack_public_path__ + "img/icon3.7d928fa1.svg";